<head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
</head>
<div class="main-area mb-3">
  <div class="search-area">
    <div class="input-group stylish-input-group">
      <input type="text" class="form-control" placeholder="Search">
      <button class="input-group-addon icon-btn"><i class="fa fa-search"></i></button>
    </div>
  </div>
</div>
